import GamePlayItem from "./../classes/GamePlayItem";
import kpiLevelAndDirection from "./../constants/data-rules/kpiLevelAndDirectionList";
import {BehaviourByNames} from "@/item-editor/constants/BehaviourTypes";

const ITEM_MAX_LEVEL_TRANSFORM = 120;

export default {
    getVisualSmpGem(){
        /*use visual smpGem always 1 from Front End for push to Unity Game Item inventory*/
        return 1;
    },

    getSmpGemUnit(config){
        if(config.smpGem !== undefined){
            return config.smpGem;
        }

        //old rule, was not apply yet, because smpGem always set with Gold drop item
        let bonus = 0;
        if(config.configOnMultiple){
            config.configOnMultiple.forEach(cfm => {
                bonus+=cfm.startBonusPercentage;
            });
        }
        if(bonus === 0){
            bonus = config.startBonusPercentage;
        }
        if(config.impactType === BehaviourByNames.incGoldDrop
            || config.impactType === BehaviourByNames.incGoldEnemyDrop){
            let smpGem = Math.round(bonus / 100);//bonus 100% was easy debug cost to buy, will cost 1 SMPGem, mean equal to gold per drop
            smpGem = Math.max(1, smpGem);
            return smpGem;
        } else if(config.impactType === BehaviourByNames.fillHp) {
            let smpGem = Math.round(2 * (bonus / 100));//bonus 100% will cost 1 SMPGem, mean equal to gold per drop
            smpGem = Math.max(1, smpGem);
            return smpGem;
        } else if (config.impactType === BehaviourByNames.incBagSlot) {
                let smpGem = Math.round(20 * (bonus / 100));//increase cost for bag slot from 10 to 15
                smpGem = Math.max(1, smpGem);
                return smpGem;

        } else {
            let smpGem = Math.round(10 * (bonus / 100));
            smpGem = Math.max(1, smpGem);
            return smpGem;
        }
    },

    getItemLevelConfig(gameLevel, levelRangeSelect){
        let levelStart = gameLevel.levelStart > 0 ? gameLevel.levelStart : 20;
        let levelEnd = gameLevel.levelEnd > 0 ? gameLevel.levelEnd : -1;
        let levelConfig = {
            'startLevel': levelStart,
            'levelRangePerLevel': levelRangeSelect,
            'kpiLevel': gameLevel.kpiLevel ? gameLevel.kpiLevel : levelStart,
            'endLevel' : levelEnd
        };
        return levelConfig;
    },

    getSiblingItems(baseGroupItem, baseItem, groupIcons){
        let resultItems = [];

        let mergedItems = baseGroupItem.mergedItems;
        for(let i=0;i<mergedItems.length;i++){
            let item = new GamePlayItem(baseItem);

            //merge custom item
            let mergedItem = mergedItems[i];
            let levelConfig = mergedItem.levelConfig;
            item.level = mergedItem.level;
            item.gameLevel = {};
            item.gameLevel.levelStart = levelConfig.levelStart;
            item.gameLevel.levelEnd = levelConfig.levelEnd;
            item.gameLevel.kpiLevel = levelConfig.kpiLevel;
            item.gameLevel.smpGem = levelConfig.smpGem;

            for(let index = 0;index<item.behaviours.length;index++){
                item.behaviours[index].gamePlayImpact.value = mergedItem.percentOfImpacts[index];
            }

            this.UpdateTransformIcon(item, groupIcons);

            resultItems.push(item);
        }

        /*old sibling item
        let config = baseGroupItem.config;
        for (let gameLevel = lvStart; gameLevel < config.endLevel; gameLevel += config.levelRangeSelect) {
            let item = new GamePlayItem(baseItem);
            let levelConfig = this.getItemLevelConfig(item.gameLevel, config.levelRangeSelect);
            item.level = this.getItemLevelAndApplyItemGameLevel(gameLevel, item.gameLevel, levelConfig);
            item.levelConfig = levelConfig;
            resultItems.push(item);
        }*/
        return resultItems;
    },

    UpdateTransformIcon(item, groupIcons){
        if(groupIcons && groupIcons.length > 0){
            let lv = item.level;
            let n = ITEM_MAX_LEVEL_TRANSFORM / groupIcons.length;
            n = Math.max(1, n);
            let index = Math.floor(lv * 1.0 / n);
            index = Math.min(groupIcons.length - 1, index);
            item.iconName = groupIcons[index];
            //console.log(`FRont Level: ${lv} n: ${n} index: ${index} iconName: ${item.iconName} legacyIcon: ${item.legacyIcon}`)
        }
    },

    getItemLevelAndApplyItemGameLevel(gameLevel, itemGameLevel, levelConfig) {
        let itemLevel = this.getItemLevel(gameLevel, levelConfig);
        itemGameLevel.levelStart = levelConfig.startLevel + ((itemLevel - 1) * levelConfig.levelRangePerLevel);
        itemGameLevel.levelEnd = itemGameLevel.levelStart + levelConfig.levelRangePerLevel;
        //update new kpiLevel by new levelStart
        levelConfig.kpiLevel = this.getKpiLevelItemLevel(gameLevel, levelConfig);
        itemGameLevel.kpiLevel = levelConfig.kpiLevel;
        return itemLevel;
    },
    getItemLevel(gameLevel, levelConfig) {
        let level = 1;
        let levelRange = gameLevel - levelConfig.startLevel;
        if (levelRange > 0 && levelRange >= levelConfig.levelRangePerLevel) {
            level += Number.parseInt((Math.floor(levelRange * 1.0 / levelConfig.levelRangePerLevel)).toString());
        }
        return level;
    },
    getKpiLevelItemLevel(gameLevel, levelConfig) {
        //to fix old data don't have kpiLevel
        if (levelConfig.kpiLevel <= 0) {
            levelConfig.kpiLevel = levelConfig.startLevel;
        }
        let itemLevel = this.getItemLevel(gameLevel, levelConfig);
        let curKpiLevel = levelConfig.kpiLevel + levelConfig.levelRangePerLevel * (itemLevel - 1);

        //Apply kpiLevel limit, to too high item cost in other range
        curKpiLevel = this.getKpiLevelWithOutRangeLimit(gameLevel, curKpiLevel);

        return curKpiLevel;
    },

    getKpiLevelByDirection(behaviourBean, levelStart){
       let diKpi = kpiLevelAndDirection.filter((k) => {
           if(k.type === behaviourBean.type){
               return k.receivers.length === behaviourBean.receivers.length &&
                   k.receivers.every((v, i) => v.value === behaviourBean.receivers[i].value);
           } else{
               return false;
           }
        });
       if(diKpi && diKpi.length > 0){
           if(diKpi.length > 1) console.log('duplicate di kpi level const');
           return levelStart + diKpi[0].diKpiLevel;
       } else {
           console.log('no di kpi level const');
           return levelStart;
       }
    },

    getKpiLevelWithOutRangeLimit(startLevel, kpiLevel){
        let trim1KStartLv = Math.floor(startLevel / 100);
        let trim1KKpi = Math.floor(kpiLevel / 100);
        if(trim1KKpi > trim1KStartLv){
            return trim1KKpi * 100;
        } else {
            return kpiLevel;
        }
    }
}
